import * as React from "react";
const SvgToggle = props => <svg width={7} height={9} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7 4.5.25 8.4V.6L7 4.5Z" fill="currentColor" /></svg>;
export default SvgToggle;